import type { CSSProperties, ReactNode } from 'react'

interface CallSurfaceProps {
  ariaLabel: string
  compact: boolean
  controls?: ReactNode
  mediaImage?: string
  profile?: ReactNode
  top: ReactNode
  variant: 'incoming' | 'outgoing'
}

export function CallSurface({ ariaLabel, compact, controls, mediaImage, profile, top, variant }: CallSurfaceProps) {
  const escapedMediaImage = mediaImage?.replace(/"/g, '\\"')
  const style = escapedMediaImage
    ? ({ '--call-surface-media-image': `url("${escapedMediaImage}")` } as CSSProperties)
    : undefined

  return (
    <div
      className={`call-surface-overlay call-surface-overlay-${variant}${
        compact ? ' call-surface-overlay-compact' : ''
      }`}
      role="dialog"
      aria-modal={!compact}
      aria-label={ariaLabel}
    >
      <div
        className={`call-surface-frame call-surface-frame-${variant}${
          compact ? ' call-surface-frame-compact' : ''
        }`}
      >
        <div className={`call-surface-media call-surface-media-${variant}`} style={style} />
        <div className={`call-surface-scrim call-surface-scrim-${variant}`} />
        {top}
        {profile}
        {controls}
      </div>
    </div>
  )
}
